import styled, { css } from 'styled-components';
import { ColorUtils, GetColor } from 'venn-ui-kit';
import { InputCSS } from '../../components/styled';

export const Idx = styled.div`
  height: 20px;
  width: 20px;
  background-color: ${GetColor.Black};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PartWrapperCSS = css`
  height: 20px;
  border-radius: 4px;
  max-width: 370px;
  display: flex;
  align-items: center;
  padding: 2px 5px;
  margin: 0 5px;
`;

export const PartWrapperButton = styled.button<{ empty?: boolean; active?: boolean; disabled?: boolean }>`
  ${PartWrapperCSS}

  border: 1px solid ${({ empty }) => (empty ? GetColor.Primary.Dark : GetColor.GreyScale.Grey40)};
  background-color: ${({ empty }) => (empty ? GetColor.White : GetColor.GreyScale.Grey10)};
  color: ${({ empty }) => (empty ? GetColor.Primary.Dark : GetColor.Black)};

  &:hover {
    ${({ empty }) =>
      empty &&
      css`
        background-color: ${ColorUtils.opacifyFrom(GetColor.Primary.Dark, 0.1)};
        color: ${GetColor.Primary.Dark};
      `}
  }

  ${({ active }) =>
    active
      ? css`
          font-weight: bold;
          color: ${GetColor.Primary.Dark};
        `
      : null}

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${GetColor.GreyScale.Grey80} !important;
    `}
`;

export const PartWrapper = styled.div`
  ${PartWrapperCSS}
  border: 1px solid ${GetColor.GreyScale.Grey40};
  background-color: ${GetColor.GreyScale.Grey10};
  color: ${GetColor.Black};
`;

export const LockedInput = styled.button`
  ${InputCSS}
  background-color: ${GetColor.GreyScale.Grey10};
  border: 1px solid ${GetColor.GreyScale.Grey40};
  color: ${GetColor.Black};
`;
